import WorkOrderView from './WorkOrderView'

export * from './WorkOrderView'
export default WorkOrderView
